import { INMEALogbookSpec, INMEAMapItem } from "../../../../../interfaces/NMEA";
import { StyledTd, StyledTr } from "../../../../../styled";
import { Autocomplete } from "@mantine/core";
import { useFormContext } from "react-hook-form";

interface Props extends INMEAMapItem {
  availableMappings: string[];
  index: number;
  watch: (name: string) => any;
  lbid: string | null;
}
const NMEAMappingItem = ({
  colName,
  availableMappings = [],
  lbid,
  index,
  watch,
}: Props) => {
  const { setValue } = useFormContext();
  const id = `list.${lbid}.${index}.mapsTo`;

  const handleChange = (value: string | null) => {
    setValue(id, value);
  };
  const value = watch(id);
  return (
    <StyledTr>
      <StyledTd>{colName}</StyledTd>
      <StyledTd>
        <Autocomplete
          data={availableMappings}
          value={value ?? ""}
          onChange={handleChange}
        />
      </StyledTd>
    </StyledTr>
  );
};
export default NMEAMappingItem;
